import { openReferenceUrl } from '@/util/chat/referenceUtils';
import { openMessageLink, toOpenableUrl } from '@/util/messageLinks';
import { Sentry } from '@/util/sentry';

const WEB_URL = /^https?:\/\//i;

/**
 * Opens a source the draft points to. A web page opens the way a reference in
 * a message does: the in-app browser on a phone, so the expert returns to the
 * draft with Done rather than finding their way back from Safari, and a new
 * tab on web, so the draft stays open. A bare `www.` address gets its scheme
 * first, or the browser cannot open it. Anything else, such as `mailto:`, goes
 * to its own app, which the in-app browser cannot open.
 *
 * A failure is reported rather than dropped, since a tap that does nothing is
 * otherwise invisible to everyone.
 */
export function openSource(url: string): void {
  const openableUrl = toOpenableUrl(url);

  if (!WEB_URL.test(openableUrl)) {
    openMessageLink(openableUrl);

    return;
  }

  openReferenceUrl(openableUrl).catch((error: Error) => {
    Sentry.captureException(error, {
      tags: { component: 'openSource', source: 'reply-draft' },
      extra: { errorMessage: error?.message, url: openableUrl },
    });
  });
}
